import React, { useState, useEffect, Fragment, useRef } from "react";
import { useParams } from "react-router-dom";
//*MUI
import { Box, Modal, TextField } from "@mui/material";
import MobileStepper from "@mui/material/MobileStepper";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { makeStyles } from "@mui/styles";

//*react-phone-number-input
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
//Icons
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { useSelector } from "react-redux";
import Countdown, { zeroPad } from "react-countdown";
//*files
import cssClasses from "./AddSiteVisit.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import CustomInput from "../../Subcomponents/CustomInput";
import CameraCapture from "../../Subcomponents/CameraCapture";
import backArrow from "../../Assets/Images/Common/backArrow.svg";
import {
  AddSite,
  CaptureImageInSiteVisit,
  getAllLeadsFromPerson,
  getCpDetailsByCpId,
  getFosDetailsByFosId,
  getInventoryTypeFromProjectName,
  getKycIdFromKycDoc,
  getLeadDetailsByLeadName,
  getLeadIdFromLeadTable,
  getProjectByProjectName,
  getUserByUserName,
  getUsersInSus,
} from "../../Services/SustenanceService";
import CustomAutoComplete from "../../Subcomponents/CustomAutoComplete";
import debounce from "lodash.debounce";
import {
  getAadharCardDetails,
  getPAN_cardDetails,
} from "../../Services/SurepassApi";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import {
  addKYCDoc,
  addLeadLogs,
  getProjects,
  updatePersonTable,
} from "../../Services/Lead";
import { getAllEvents, getSpecificLaunch } from "../../Services/AssignNewToken";
import {
  getProjectUnitType,
  checkPhoneNumberIsBlackListed,
} from "../../Services/Lead";
import {
  checkSiteVisitHasDone,
  getFosDetails,
  getUnitIdFromInventory,
  updateLeadStatus,
} from "../../Services/SiteVisit";
import { getEventByEventName } from "../../Services/Event";
import { sendOTPMessage } from "../../Services/SmsService";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from "crypto-js";
import { Network } from "@capacitor/network";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import InfoIcon from "../../Components/Icons/InfoIcon";
import DateComponent from "../../Subcomponents/DateComponent";
import { InputAdornment } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import dayjs from "dayjs";
import { getSelectedProjects } from "../../Services/AssignProject";
import { get } from "lodash";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "80%",
  width: "Fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.8rem",
    color: "#101828",
    marginBottom: "1.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));

// Format an epoch-ms / Date value as an IST date-time string for the lead log message.
const formatIST = (value) =>
  value
    ? new Date(value).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    : "NA";

// Time-only picker kept local to this modal (the shared TimeComponent is intentionally NOT used/changed).
// Shows ONLY a clock — no calendar/date selection. The caller fixes the date to "today".
function EndTimePicker({ value, helperText, onChangeTime }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileTimePicker
        value={value ? dayjs(value) : null}
        onChange={(e) => (e ? onChangeTime(e["$d"]) : onChangeTime(""))}
        // Picker UI is a clock (time only), but the input text matches the Start
        // field exactly — same "L hh:mm A" format, e.g. "06/15/2026 05:00 PM".
        inputFormat="L hh:mm A"
        PopperProps={{ placement: "bottom-start" }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CalendarTodayOutlinedIcon
                style={{
                  fontSize: "2rem",
                  marginLeft: "1.5rem",
                  color: "#667085",
                  cursor: "pointer",
                }}
              />
            </InputAdornment>
          ),
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            placeholder="HH:MM"
            helperText={helperText}
            sx={{
              "& .MuiOutlinedInput-root": {
                background: "#F2F4F7",
                borderRadius: "0.8rem",
                fontSize: "1.4rem",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border:
                  helperText !== ""
                    ? "1px solid red !important"
                    : "1px solid #F2F4F7 !important",
              },
              "& input": {
                padding: "1rem 1.4rem",
                fontSize: "1.4rem",
                color: "#667085",
              },
              "& .MuiFormHelperText-root": {
                fontSize: "1.4rem",
                margin: "0.2rem 0 0 0",
                color: "#d32f2f",
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}

function AddSiteVisit({ open, handleClose, data, modalType, returnRes }) {
  const classes = useStyles();
  let { projectId, eventID } = useParams();
  const [activeStep, setActiveStep] = useState(0);

  //*Images
  const [webCamModalToggler, setWebCamModalToggler] = useState(false);
  const [imageBase64, setImageBase64] = useState(null);

  //*SiteVisitData-Sustenance & Events
  const [AllLeads, setAllLeads] = useState([]);
  const [LeadValue, setLeadValue] = useState(null);
  const [LeadName, setLeadName] = useState("");
  const [AllUsers, setAllUsers] = useState([]);
  const [UserValue, setUserValue] = useState(null);
  const [UserName, setUserName] = useState("");
  const [UserID, setUserID] = useState("");
  const [CpName, setCpName] = useState("");
  const [CpType, setCpType] = useState("");
  const [leadType, setLeadType] = useState(false);
  const [FosData, setFosData] = useState([]);
  const [FosId, setFosId] = useState("");
  const [EntityFos, setEntityFos] = useState("");
  const [EventId, setEventId] = useState("");
  const [InventoryType, setInventoryType] = useState([]);
  const [UnitType, setUnitType] = useState([]);
  const [LeadID, setLeadID] = useState("");
  const [CpID, setCpID] = useState("");
  const [ProjectId, setProjectId] = useState("");
  const [LeadContact, setLeadContact] = useState("");
  const [EventName, setEventName] = useState("");

  //*SiteVisitData-leads
  const [EventList, setEventList] = useState([]);
  const [LaunchList, setLaunchList] = useState([]);
  const [UnitList, setUnitList] = useState([]);
  const [kycId, setKycId] = useState("");

  //*panVerify & aadhar & OTP
  const [isLoadingPan, setIsLoadingPan] = useState(false);
  const [isLoadingAadhar, setIsLoadingAadhar] = useState(false);
  const [panName, setPanName] = useState("");
  const [panObject, setPanObject] = useState(null);
  const [panNumber, setPanNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [VerifyAadhar, setVerifyAadhar] = useState(true);
  const [VerifyPan, setVerifyPan] = useState(true);
  const [VerificationTypeValue, setVerificationTypeValue] =
    useState("PAN Verification");
  const VerificationType = ["PAN Verification"];
  // !!Change only pan verification
  // "Aadhar Verification"];
  const [showOtp, setShowOtp] = useState(false);
  const startDate = React.useRef(Date.now());
  //*when verification is done and a success
  const [verified, setVerified] = useState(false);

  const [SiteVisitDetails, setSiteVisitDetails] = useState({
    UnitType: "",
    leadName: "",
    CpName: "",
    SalesRepName: "",
    LeadContactNumber: "",
    PhotoUrl: "",
    isPanValid: false,
    isAadharValid: false,
    panNumber: "",
    aadharNumber: "",
    OtpNumber: "",
    EntityType: "",
    UserName: "",
    eventTitle: "",
    launchTitle: "",
    unitTitle: "",
    unitId: "",
    fosId: "",
    fosName: "",
    fosData: null,
    eventData: null,
    launchData: null,
    unitData: null,
    contactNumber: "",
    projectId: "",
    kycId: null,
    dateTime: dayjs(Date.now()),
    remark: "",
    siteVisitMode: "Onsite",
    projectName: null,
    selectedProjectData: null
  });
  const [HelperText, setHelperText] = useState({
    UnitType: "",
    leadName: "",
    CpName: "",
    SalesRepName: "",
    LeadContactNumber: "",
    PhotoUrl: "",
    panNumber: "",
    aadharNumber: "",
    OtpNumber: "",
    EntityType: "",
    UserName: "",
    eventName: "",
    launchName: "",
    UnitTypeName: "",
    isPhoneNumber: "",
    projectId: "",
  });
  const [OtpNumber, setOtpNumber] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [verifiedKycDoc, setVerifiedKycDoc] = useState({
    docNumber: "",
    docType: "",
    docName: "",
    docObject: null,
  });
  const [isInterNational, setIsInterNational] = useState(false);
  const [recievedOtp, setRecievedOtp] = useState(null);
  const [otptimer, setOtpTimer] = useState(false);
  const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  // const [selectedChoice, setSelectedChoice] = useState("");
  const [projectList, setProjectList] = useState([]);

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [changeLeadName, setChangeLeadName] = useState(false);

  // **For multipleSiteVisits
  const [multipleSiteVisit, setMultipleSiteVisit] = useState(false);

  // **Site Visit Start/End date-time (leadSiteVisit flow) — shown in Step 1 below verification.
  // Start is locked to the current date & time when the modal opens (the modal mounts on open,
  // so the lazy initializer captures "now"). End keeps today's date; only the time is selectable.
  const [siteVisitStart, setSiteVisitStart] = useState(() => new Date());
  // End defaults to the current date & time so the input box shows today's date immediately;
  // the picker lets the user change only the time (date stays today).
  const [siteVisitEnd, setSiteVisitEnd] = useState(() => new Date());
  const [dateTimeError, setDateTimeError] = useState({ start: "", end: "" });

  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  function goBack() {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const [kycOption, setKycOtption] = useState(false);
  useEffect(() => {
    if (modalType !== "leadSiteVisit") {
      getLead();
    }
  }, []);
  //*modalType==leadSiteVisit
  useEffect(() => {
    if (modalType === "leadSiteVisit") {
      //if lead is sustenance drop down to select project
      projectListFun();
      setUserValue(data?.Sales?.name);
      setUserName(data?.Sales?.name);
      setUserID(data?.Sales?.userId);
      // console.log(data);
      getUsersInSus().then((rep) => {
        if (rep.data) {
          // console.log("UsersTable", rep);
          setAllUsers(rep.data);
        } else {
          console.log("Users-Error", rep.error);
        }
      }).catch((err) => {
        console.error("getUsersInSus", err)
      });
      setSiteVisitDetails((pre) => {
        pre.fosId = data?.FOS?.fosId === "-" ? null : data?.FOS?.fosId;
        pre.fosName = data?.FOS?.name === "-" ? null : data?.FOS?.name;
        // pre.fosData = data?.FOS;
        pre.contactNumber = "+" + data?.leadDetails?.contactNumber;
        pre.projectName = data?.projectname
        return { ...pre };
      });

      getAllEvents()
        .then((resp) => {
          // console.log(resp);
          setEventList(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
      if (data?.CP?.cpId !== "-") {
        getFoSDetails(data?.CP?.cpId);
      }
    }
    if (modalType === "SustenanceSiteVisit") {
      getLead();
      getProjectDetails();
    }
    if (modalType === "EventSiteVisit") {
      getLead();
      getEventForAdd();
      // setUserName(AllUsers.data[0].name)
    }
    if (modalType === "SustenanceSiteVisit") {
      getProjectInfo()
      // console.log("kyc-option" , kycOption)
    }
  }, []);

  useEffect(() => {
    // console.log(verifiedPhoneNumber, OtpNumber);
  }, [verifiedPhoneNumber, OtpNumber]);


  // **Check if Site Visit has done already
  useEffect(() => {
    if (modalType === "leadSiteVisit") {
      checkSiteVisitHasDone(data.leadId).then((leadSiteVisitDone) => {
        // console.log({ leadSiteVisitDone });
        if (leadSiteVisitDone.count > 0) {
          setSiteVisitDetails((pre) => {
            pre.projectId = leadSiteVisitDone.data[0].projectId;
            pre.kycId = leadSiteVisitDone.data[0].kycId;
            return { ...pre };
          });
          setMultipleSiteVisit(true);
          setVerified(true);
        }
      }).catch((err) => {
        console.error("checkSiteVisitHasDone", err)
      });
    }
  }, []);

  // useEffect(() => {
  //   console.log(imageBase64);
  //   if (multipleSiteVisit && uploadPhoto) {
  //     if (imageBase64) {
  //       document.getElementById("uploadedImage").src =
  //         URL.createObjectURL(imageBase64);
  //     }
  //   }
  // }, [imageBase64]);

  function projectListFun() {
    getProjects(loggedInUser.id).then((resp) => {
      console.log("All Projects get by projectListFun--------------->", resp);
      
      setProjectList([...resp]);
      //console.log("Assigned Project", resp);
      console.log("Logged In User-------->", loggedInUser);
      console.log("Assigned Projects-------->", loggedInUser?.assignedProjects);
    }).catch((err) => {
      console.error("getProjects", err)
    });
  }

  //*Common-function-calls
  const PAN_CardCheck = useRef(
    debounce((e, _apiToken) => {
      // console.log(e);
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPan(false);
          // console.log("Pan-Card-Data", res.data);
          if (res?.data?.message_code === "success") {
            setVerifyPan(false);
            setHelperText((pre) => {
              pre.isPanValid = true;
              pre.panNumber = "";
              return { ...pre };
            });
            // console.log("res.data.data.full_name", res.data.data.full_name);
            setPanName(
              res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ")
            );
            setPanObject(res.data.data);
            setVerifiedKycDoc((pre) => {
              pre.docName = res.data.data.full_name
                .toUpperCase()
                .replace(/\s\s+/g, " ");
              pre.docNumber = e;
              pre.docType = "PanCard";
              pre.docObject = res.data;
              return { ...pre };
            });
          } else {
            setIsLoadingPan(false);
            // setPAN_cardIsVerified(false);
          }
        })
        .catch((err) => {
          setIsLoadingPan(false);
          // console.log("err", err);
          // console.log(err?.response?.data);
          if (err?.response?.data?.message) {
            setPanName("");
            let pre = { ...HelperText };
            pre.panNumber = err?.response?.data?.message;
            pre.isPanValid = false;

            setHelperText({ ...pre });
          } else {
            // console.log("error-pan", err.response.data.message_code);
            errorTost(err.response.data.message_code);
          }
        });
    }, 800)
  ).current;

  const AADHAR_CardCheck = useRef(
    debounce((e) => {
      // console.log(e);
      getAadharCardDetails(e)
        .then((res) => {
          setIsLoadingAadhar(false);
          // console.log(res.data);
          if (res?.data?.message_code === "success") {
            // console.log("res.data.data.full_name",res.data.data.full_name);
            setVerifyAadhar(false);
            setHelperText((pre) => {
              pre.isAadharValid = true;
              pre.aadharNumber = "";
              return { ...pre };
            });
            setVerifiedKycDoc((pre) => {
              pre.docName = "";
              pre.docNumber = aadharNumber;
              pre.docType = "AadharCard";
              pre.docObject = res.data;
              return { ...pre };
            });
            console.log("AAdhar-data", res);
          } else {
            setIsLoadingAadhar(false);
          }
        })
        .catch((err) => {
          setIsLoadingAadhar(false);
          console.log("err", err);
          // console.log(err?.response?.data);

          if (err?.response?.data?.message) {
            setPanName("");
            let pre = { ...HelperText };
            pre.aadharNumber = err?.response?.data?.message;
            pre.isAadharValid = false;

            setHelperText({ ...pre });
          } else {
            // console.log("error-aadhar", err.response.data.message_code);
            errorTost(err.response.data.message_code);
          }
        });
    }, 800)
  ).current;

  function CancelClose() {
    handleClose();
    setActiveStep(0);
    setSiteVisitStart(null);
    setSiteVisitEnd(null);
    setDateTimeError({ start: "", end: "" });
  }

  // **Validate Start/End date-time (leadSiteVisit only): both required, End must be after Start
  function validateSiteVisitDateTimes() {
    let valid = true;
    let errors = { start: "", end: "" };
    if (!siteVisitStart) {
      errors.start = "Please select site visit start date & time";
      valid = false;
    }
    if (!siteVisitEnd) {
      errors.end = "Please select site visit end date & time";
      valid = false;
    }
    if (
      siteVisitStart &&
      siteVisitEnd &&
      new Date(siteVisitEnd).getTime() <= new Date(siteVisitStart).getTime()
    ) {
      errors.end = "End date & time must be after start date & time";
      valid = false;
    }
    setDateTimeError(errors);
    return valid;
  }

  //*aadhar-verification
  function AadharVerify() {
    // console.log("AAdhar---", aadharNumber);
    if (aadharNumber !== "") {
      getKycIdFromKycDoc(aadharNumber)
        .then((res) => {
          // console.log("res-aadhar", res);
          if (res.data.length === 0) {
            dismissLoader();
            successTost("Verified Successfully");
            setVerified(true);
            // console.log("kycccccc-aadhar", res);
          } else {
            dismissLoader();
            setHelperText((pre) => {
              pre.aadharNumber = "Aadhar number already exists!";
              pre.isAadharValid = false;
              return { ...pre };
            });
            setVerified(false);
          }
        })
        .catch((err) => {
          dismissLoader();
          setVerified(false);
          errorTost(err);
        });
    }
  }

  //*pan-verification
  function PanVerify() {
    if (panNumber !== "") {
      getKycIdFromKycDoc(panNumber)
        .then((res) => {
          // console.log("res" , res)
          if (res.data.length === 0) {
            // console.log("checkRes", res.data);
            dismissLoader();
            if (modalType === "leadSiteVisit") {
              if (data.leadname !== panName) {
                setOpenConfirmation(true);
              } else {
                setVerified(true);
                successTost("Verified Successfully");
              }
            } else {
              setVerified(true);
              successTost("Verified Successfully");
            }

            // console.log("kycccccc-pan", res);
          } else {
            dismissLoader();
            setHelperText((pre) => {
              pre.panNumber = "Pan number already exists!";
              pre.isPanValid = false;
              return { ...pre };
            });
            setVerified(false);
          }
        })
        .catch((err) => {
          dismissLoader();
          setVerified(false);
          errorTost(err);
        });
    }
  }

  //*to get project-Data
  function getProjectInfo() {
    getProjectByProjectName(projectId).then((response) => {
      // console.log("Project-Details" , response)
      if (response.data[0].panVerificationForSiteVisit === true) {
        setKycOtption(true)
      }
    }).catch((err) => {
      console.error("getProjectByProjectName", err)
    })
  }

  //*saving-base64-image
  function SavingImageData() {
    setWebCamModalToggler(false);
    // console.log("Image-Upload", imageBase64);
  }

  //*Lead-function-calls
  function getLaunchDetails(eventId, search) {
    getSpecificLaunch(eventId, search)
      .then((resp) => {
        // console.log("launch", { resp });
        setLaunchList(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getUnitId(projectId) {
    // getUnitIdFromInventory(projectId).then((resp)=>{
    // console.log(resp.data[0]);
    //   setSiteVisitDetails((pre)=>{
    //     pre.unitData=resp.data;
    //     return {...pre}
    //   });
    // });

    getInventoryTypeFromProjectName(projectId).then((response1) => {
      // console.log("InventoryType", response1.data);
      setInventoryType(response1.data);
    }).catch((err) => {
      console.error("setInventoryType", err)
    });
  }
  function getUnitTypeDetails(projectId) {
    getUnitId(projectId);
    // console.log(projectId);
    getProjectUnitType(projectId)
      .then((resp) => {
        // console.log(resp);
        resp = resp.map((el) => {
          return el.type;
        });
        setUnitList(resp);
        // console.log(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //*getFos Names Under particular Cp
  function getFoSDetails(cpId) {
    // console.log(cpId);
    getFosDetails(cpId)
      .then((resp) => {
        setFosData(resp.data);
        // console.log({ resp });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //*Sustenance-function-calls &Events
  function getProjectDetails() {
    setProjectId(projectId);
    // console.log("ProjectId", ProjectId);
    getInventoryTypeFromProjectName(projectId)
      .then((response1) => {
        // console.log("InventoryType", response1.data);
        setInventoryType(response1.data);
      })
      .catch((err) => {
        console.error("getInventoryTypeFromProjectName", err);
      });
  }

  function getLead() {
    getAllLeadsFromPerson()
      .then((res) => {
        if (res.data) {
          setAllLeads(res.data);
          // console.log("leads", res.data);
        } else {
          console.log("error", res.error);
        }
      })
      .catch((err) => {
        console.error("leads", err);
      });

    getUsersInSus()
      .then((rep) => {
        if (rep.data) {
          // console.log("UsersTable", rep);
          setAllUsers(rep.data);
        } else {
          console.log("Users-Error", rep.error);
        }
      })
      .catch((err) => {
        console.error("UsersTable", err);
      });
  }

  function getEventForAdd() {
    getLaunchDetails(eventID);
    setEventId(eventID);
    getEventByEventName(eventID)
      .then((response111) => {
        // console.log("Event-Name", response111[0].title);
        setEventName(response111[0].title);
      })
      .catch((err) => {
        console.error("Event-Name", err);
      });
  }

  const OnChangeOfLeadName = debounce((_value) => {
    // console.log("_value =>", _value);
    if (_value !== "") {
      // console.log("_InitialValue", _value?.toString().split(" - ")[0]);
      const SelectedValue = _value?.toString().split(" - ")[0];
      // console.log("_value", SelectedValue);
      if (SelectedValue !== "") {
        setLeadName(_value);
        getLeadDetailsByLeadName(SelectedValue)
          .then((res) => {
            if (res.data !== "") {
              console.log("Person-Table", res);
              setLeadContact(res.data[0].contactNumber);
              setSiteVisitDetails((pre) => {
                pre.LeadContactNumber = "+" + res.data[0].contactNumber;
                return { ...pre };
              });
              getLeadIdFromLeadTable(res.data[0].personId)
                .then((res2) => {
                  if (res2.data !== "") {
                    console.log("Leads-Table", res2);
                    if (
                      res2.data[0].leadType === "Direct" ||
                      res2.data[0].leadType === "R&L"
                    ) {
                      setLeadType(true);
                      setLeadID(res2.data[0].leadId);
                    } else {
                      setLeadType(false);
                      console.log("res2.data[0].leadId", res2.data[0].leadId);
                      setLeadID(res2.data[0].leadId);
                      getCpDetailsByCpId(res2.data[0].cpId)
                        .then((resp) => {
                          if (resp.data !== "") {
                            setCpID(resp.data[0].cpId);
                            console.log("CP-Table", resp);
                            setCpName(resp.data[0].name);
                            setCpType(resp.data[0].CP.cpType);
                            if (res2.data[0].fosId !== null) {
                              getFosDetailsByFosId(res2.data[0].fosId)
                                .then((response2) => {
                                  if (response2.data !== "") {
                                    if (res2.data[0].fosId !== "") {
                                      setFosId(res2.data[0].fosId);
                                    } else {
                                      setFosId(null);
                                    }
                                    console.log("FOS-Table", response2.data);
                                    setFosData(response2.data);
                                  } else {
                                    console.log(
                                      "Fos-Name-Error",
                                      response2.error
                                    );
                                  }
                                })
                                .catch((err) => {
                                  console.log("Fos-error", err);
                                });
                            }
                          } else {
                            console.log("Cp-Name-error", resp.error);
                          }
                        })
                        .catch((err) => {
                          console.log("Cp-error", err);
                        });
                    }
                  } else {
                    console.log("Lead-Name-error", res2.error);
                  }
                })
                .catch((err) => {
                  console.log("lead-name-error", err);
                });
            } else {
              console.log("LeadName-table", res.error);
            }
          })
          .catch((err) => {
            console.log("LeadName-table-error", err);
          });
      }
    } else {
      setLeadName(_value);
      console.log("Lead-Name-is-empty", _value);
    }
  });

  const OnChangeOfUserName = debounce((_value) => {
    console.log(_value);
    if (_value !== " ") {
      console.log("-User", _value);
      setUserName(_value);
      setSiteVisitDetails((pre) => {
        pre.UserName = _value;
        return { ...pre };
      });
      getUserByUserName(_value).then((response3) => {
        console.log(response3);
        if (response3.data) {
          console.log("User", response3.data[0].userId);
          setUserID(response3.data[0].userId);
        } else {
          console.log("User-Name-Error", response3.error);
        }
      }).catch((err) => {
        console.error("getUserByUserName", err)
      });
    } else {
      console.log("User-Name-Value-is-empty", _value);
    }
  });

  function validateSiteVisitData() {
    var form = true;
    if (modalType === "SustenanceSiteVisit") {
      if (SiteVisitDetails.UnitType === "") {
        form = false;
        setHelperText((pre) => {
          pre.UnitType = "Please select unitType";
          return { ...pre };
        });
      }
      if (SiteVisitDetails.leadName === "") {
        form = false;
        setHelperText((pre) => {
          pre.leadName = "Please select Lead";
          return { ...pre };
        });
      }
      if (SiteVisitDetails.UserName === "") {
        form = false;
        setHelperText((pre) => {
          pre.UserName = "Please select Sales Manager";
          return { ...pre };
        });
      }

      if (
        CpType === "Entity" &&
        FosData.length > 1 &&
        SiteVisitDetails.EntityType === ""
      ) {
        form = false;
        setHelperText((pre) => {
          pre.EntityType = "Please select Entity";
          return { ...pre };
        });
      }
      if (imageBase64 === null) {
        form = false;
        errorTost("Please Capture Photo");
      }
    }

    if (modalType === "leadSiteVisit") {
      if (SiteVisitDetails.projectId === "") {
        form = false;
        setHelperText((pre) => {
          pre.projectId = "Please select project";
          return { ...pre };
        });
      }

      if (UserName === "") {
        form = false;
        setHelperText((pre) => {
          pre.UserName = "Please select user name";
          return { ...pre };
        });
      }
      if (imageBase64 === null) {
        form = false;
        errorTost("Please Capture Photo");
      }
    }

    if (modalType === "EventSiteVisit") {
      if (SiteVisitDetails.leadName === "") {
        form = false;
        setHelperText((pre) => {
          pre.leadName = "Please select Lead";
          return { ...pre };
        });
      }
      if (SiteVisitDetails.UserName === "") {
        form = false;
        setHelperText((pre) => {
          pre.UserName = "Please select Sales Manager";
          return { ...pre };
        });
      }

      if (SiteVisitDetails.launchTitle === "") {
        form = false;
        setHelperText((pre) => {
          pre.launchName = "Please select launch title";
          return { ...pre };
        });
      }
      if (SiteVisitDetails.unitId === "") {
        form = false;
        setHelperText((pre) => {
          pre.UnitTypeName = "Please select unit type";
          return { ...pre };
        });
      }

      if (
        CpType === "Entity" &&
        FosData.length > 1 &&
        SiteVisitDetails.EntityType === ""
      ) {
        form = false;
        setHelperText((pre) => {
          pre.EntityType = "Please select Entity";
          return { ...pre };
        });
      }
      if (imageBase64 === null) {
        form = false;
        errorTost("Please Capture Photo");
      }
    }

    return {
      flag: form,
    };
  }

  function AddSiteVisitData() {
    let flag = validateSiteVisitData();
    if (flag.flag) {
      handleNext();
    }
  }
  //*phone number check,number is in blacklisted
  const IsNumberBlackListed = debounce((e) => {
    console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        console.log(resp);
        if (resp.length > 0) {
          setVerifiedPhoneNumber(false);
          setHelperText((pre) => {
            pre.isPhoneNumber = "This number has been blacklisted";
            return { ...pre };
          });
          // helperText.isPhoneNumber = "This number has been blacklisted";
        } else {
          setHelperText((pre) => {
            pre.isPhoneNumber = "";
            return { ...pre };
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800);
  // !!If SM changes update Leads table for userParentId (check add lead modal for preference)


  //*insert-query-to-Site-visit
  function OnSubmit() {
    if (modalType === "leadSiteVisit") {
      // console.log(SiteVisitDetails.unitData);
      // **Start/End date-time are required and End must be after Start
      if (!validateSiteVisitDateTimes()) {
        errorTost("Please select valid site visit start and end date & time");
        return;
      }
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
      if (
        HelperText.isPhoneNumber === "" &&
        verified &&
        HelperText.aadharNumber === "" &&
        HelperText.panNumber === "" &&
        verifiedPhoneNumber
      ) {
        // console.log(verifiedKycDoc);
        Network.getStatus().then((status) => {
          if (status.connected) {
            presentLoader();
            if (multipleSiteVisit === false) {
              // **To check is Pan Number has Entered
              if (verifiedKycDoc.docNumber !== '') {
                addKYCDoc(
                  data?.leadId,
                  verifiedKycDoc.docNumber,
                  verifiedKycDoc.docName,
                  verifiedKycDoc.docObject,
                  verifiedKycDoc.docType
                )
                  .then((rep) => {
                    // console.log("add-Pan", rep);
                    setKycId(rep[0].kycId);
                    let SiteVisitData = {
                      leadId: data?.leadId,
                      dateTime: new Date(SiteVisitDetails.dateTime).getTime(),
                      startDateTime: siteVisitStart ? new Date(siteVisitStart).getTime() : null,
                      endDateTime: siteVisitEnd ? new Date(siteVisitEnd).getTime() : null,
                      photoUrl: "",
                      projectId: SiteVisitDetails.projectId,
                      kycId: rep[0].kycId,
                      cpId: data?.CP?.cpId === "-" ? null : data?.CP?.cpId,
                      fosId: SiteVisitDetails?.fosId,
                      userId: UserID,
                      remarks: SiteVisitDetails.remark,
                      mode: SiteVisitDetails.siteVisitMode,
                    };
                    console.log("MODE being sent to API: ", SiteVisitDetails.siteVisitMode);
                    AddSite(SiteVisitData)
                      .then((response5) => {
                        if (response5) {
                          // console.log("added-response", response5);
                          if (imageBase64 !== "" || imageBase64 !== null) {
                            if (imageBase64)
                              CaptureImageInSiteVisit(
                                imageBase64,
                                response5[0].siteVistId
                              ).then((response6) => {
                                // console.log("Capture-Image", response6);
                              });
                          }
                          updateLeadStatus(data?.leadId, "Site Visit Done")
                            .then((resp) => {
                              let obj = {
                                cpId: data.cpid,
                                fosId: data.fosid,
                                userId: loggedInUser.userId,
                                leadId: data.leadId,
                                leadStatus: resp[0].status,
                                message: `Site visit for ${SiteVisitDetails.projectName} done by ${loggedInUser.name}(${loggedInUser.roleId.title}). ${SiteVisitDetails.remark ? `\nRemark : ${SiteVisitDetails.remark}` : ""}\nStart: ${formatIST(siteVisitStart)}\nEnd: ${formatIST(siteVisitEnd)}`,
                              };
                              addLeadLogs(obj)
                                .then((leadLog) => {
                                  // console.log(leadLog);
                                })
                                .catch((err) => {
                                  console.log("leadlog", err);
                                });
                              dismissLoader();
                              // console.log(resp);
                              returnRes(true);
                              if (changeLeadName) {
                                successTost(
                                  `${panName} Site Visit done successfully!`
                                );
                              } else {
                                successTost(
                                  `${data?.leadname} Site Visit done successfully!`
                                );
                              }
                              handleClose();
                            })
                            .catch((err) => {
                              dismissLoader();
  
                              console.log("err while updating leadStatus", err);
                            });
                        } else {
                          dismissLoader();
                          errorTost("Something went Wrong! Try Again");
                        }
                        if (changeLeadName) {
                          updatePersonTable(panName, data?.person?.personId)
                            .then((resp) => { })
                            .catch((err) => {
                              console.log(err);
                              errorTost(err.message);
                            });
                        }
                      })
                      .catch((errWhileAddingSiteVisit) => {
                        dismissLoader();

                        console.log(
                          "error while adding Site Visit",
                          errWhileAddingSiteVisit
                        );
                      });
                  })
                  .catch((errAddKyc) => {
                    dismissLoader();
                    console.log("error while adding kyc", errAddKyc);
                  });

              } else {
                // **Optional Kyc
                let SiteVisitData = {
                  leadId: data?.leadId,
                  dateTime: new Date(SiteVisitDetails.dateTime).getTime(),
                  startDateTime: siteVisitStart ? new Date(siteVisitStart).getTime() : null,
                  endDateTime: siteVisitEnd ? new Date(siteVisitEnd).getTime() : null,
                  photoUrl: "",
                  projectId: SiteVisitDetails.projectId,
                  kycId: null,
                  cpId: data?.CP?.cpId === "-" ? null : data?.CP?.cpId,
                  fosId: SiteVisitDetails?.fosId,
                  userId: UserID,
                  remarks: SiteVisitDetails.remark,
                  mode: SiteVisitDetails.siteVisitMode
                };
                AddSite(SiteVisitData)
                  .then((response5) => {
                    if (response5) {
                      // console.log("added-response", response5);
                      if (imageBase64 !== "" || imageBase64 !== null) {
                        if (imageBase64) {
                          CaptureImageInSiteVisit(
                            imageBase64,
                            response5[0].siteVistId
                          ).then((response6) => {
                            console.log("Capture-Image", response6);
                          }).catch((err) => {
                            console.error("add-image-to-storage-err", err)
                          });
                        }
                      }
                      updateLeadStatus(data?.leadId, "Site Visit Done")
                        .then((resp) => {
                          let obj = {
                            cpId: data.cpid,
                            fosId: data.fosid,
                            userId: loggedInUser.userId,
                            leadId: data.leadId,
                            leadStatus: resp[0].status,
                            message: `Site visit for ${SiteVisitDetails.projectName} done by ${loggedInUser.name}(${loggedInUser.roleId.title}).  ${SiteVisitDetails.remark ? ` \nRemark : ${SiteVisitDetails.remark} ` : ""}\nStart: ${formatIST(siteVisitStart)}\nEnd: ${formatIST(siteVisitEnd)}`,
                          };
                          addLeadLogs(obj)
                            .then((leadLog) => {
                              console.log(leadLog);
                            })
                            .catch((err) => {
                              console.log("leadlog", err);
                            });
                          dismissLoader();
                          console.log(resp);
                          returnRes(true);
                          if (changeLeadName) {
                            successTost(
                              `${panName} Site Visit done successfully!`
                            );
                          } else {
                            successTost(
                              `${data?.leadname} Site Visit done successfully!`
                            );
                          }
                          handleClose();
                        })
                        .catch((err) => {
                          dismissLoader();

                          console.log("err while updating leadStatus", err);
                        });
                    } else {
                      dismissLoader();
                      errorTost("Something went Wrong! Try Again");
                    }
                    if (changeLeadName) {
                      updatePersonTable(panName, data?.person?.personId)
                        .then((resp) => { })
                        .catch((err) => {
                          console.log(err);
                          errorTost(err.message);
                        });
                    }
                  })
                  .catch((errWhileAddingSiteVisit) => {
                    dismissLoader();

                    console.log(
                      "error while adding Site Visit",
                      errWhileAddingSiteVisit
                    );
                  });
              }
            } else {
              let SiteVisitData = {
                leadId: data?.leadId,
                dateTime: new Date(SiteVisitDetails.dateTime).getTime(),
                startDateTime: siteVisitStart ? new Date(siteVisitStart).getTime() : null,
                endDateTime: siteVisitEnd ? new Date(siteVisitEnd).getTime() : null,
                photoUrl: "",
                projectId: SiteVisitDetails.projectId,
                kycId: SiteVisitDetails.kycId,
                cpId: data?.CP?.cpId === "-" ? null : data?.CP?.cpId,
                fosId: SiteVisitDetails?.fosId,
                userId: UserID,
                remarks: SiteVisitDetails.remark,
                mode: SiteVisitDetails.siteVisitMode
              };
              AddSite(SiteVisitData)
                .then((response5) => {
                  if (response5) {
                    // console.log("added-response", response5);
                    if (imageBase64 !== "" || imageBase64 !== null) {
                      if (imageBase64) {
                      CaptureImageInSiteVisit(
                        imageBase64,
                        response5[0].siteVistId
                      ).then((response6) => {
                          // console.log("Capture-Image", response6);
                        }).catch((err) => {
                          console.error("add-image-to-storage-err", err)
                        });
                      }
                    }
                        updateLeadStatus(data?.leadId, "Site Visit Done")
                          .then((resp) => {
                            let obj = {
                              cpId: data.cpid,
                              fosId: data.fosid,
                              userId: loggedInUser.userId,
                              leadId: data.leadId,
                              leadStatus: resp[0].status,
                              message: `Site visit for ${SiteVisitDetails.projectName} done by ${loggedInUser.name}(${loggedInUser.roleId.title}). ${SiteVisitDetails.remark && ` \nRemark  : ${SiteVisitDetails.remark}`}\nStart: ${formatIST(siteVisitStart)}\nEnd: ${formatIST(siteVisitEnd)}`,
                            };
                            addLeadLogs(obj)
                              .then((leadLog) => {
                                console.log(leadLog);
                              })
                              .catch((err) => {
                                console.log("leadlog", err);
                              });
                            dismissLoader();
                            // console.log(resp);
                            returnRes(true);
                            successTost(
                              `${data?.leadname} Site Visit done successfully!`
                            );
                            handleClose();
                          })
                          .catch((err) => {
                            dismissLoader();
                            console.log("err while updating leadStatus", err);
                          });
                  } else {
                    dismissLoader();
                    errorTost("Something went Wrong! Try Again");
                  }
                  if (changeLeadName) {
                    updatePersonTable(panName, data?.person?.personId)
                      .then((resp) => { })
                      .catch((err) => {
                        console.log(err);
                        errorTost(err.message);
                      });
                  }
                })
                .catch((errWhileAddingSiteVisit) => {
                  dismissLoader();

                  console.log(
                    "error while adding Site Visit",
                    errWhileAddingSiteVisit
                  );
                });
            }
          } else {
            offlineToast();
          }
        }).catch((err) => {
          console.error("Leads-Network-err", err)
        });
      }
      // }
    }
    //<------------------------------------------------------------------------------------------------------->//
    else if (modalType === "SustenanceSiteVisit") {
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
      if (
        HelperText.isPhoneNumber === "" &&
        verified &&
        HelperText.aadharNumber === "" &&
        HelperText.panNumber === "" &&
        verifiedPhoneNumber
      ) {
        Network.getStatus().then((status) => {
          if (status.connected) {
            presentLoader();
            // console.log("imageBase64", imageBase64);
            if (verifiedKycDoc.docNumber !== '') {
              addKYCDoc(
                LeadID,
                verifiedKycDoc.docNumber,
                verifiedKycDoc.docName,
                verifiedKycDoc.docObject,
                verifiedKycDoc.docType
              ).then((rep) => {
                let SiteVisitData = {
                  leadId: LeadID,
                  dateTime: Date.now(),
                  photoUrl: "",
                  projectId: ProjectId,
                  kycId: rep[0].kycId,
                  cpId: CpID ? CpID : null,
                  fosId: FosId ? FosId : null,
                  inventoryTypeId: UnitType,
                  userId: UserID,
                  mode: SiteVisitDetails.siteVisitMode
                };
                // console.log("SiteVisitData", SiteVisitData);
                AddSite(SiteVisitData).then((response5) => {
                  if (response5) {
                    // console.log("added-response", response5);
                    if (imageBase64 !== "" || imageBase64 !== null) {
                      if (imageBase64) {
                        // console.log("imageBase64", imageBase64);
                        CaptureImageInSiteVisit(
                          imageBase64,
                          response5[0].siteVistId
                        ).then((response6) => {
                          // console.log("Capture-Image", response6);
                        });
                      }
                      handleClose();
                      updateLeadStatus(LeadID, "Site Visit Done")
                        .then((resp) => {
                          let obj = {
                            cpId: CpID ? CpID : null,
                            fosId: FosId ? FosId : null,
                            userId: UserID,
                            leadId: LeadID,
                            leadStatus: resp[0].status,
                            message: `Site visit done by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                          };
                          addLeadLogs(obj)
                            .then((leadLog) => {
                              console.log(leadLog);
                            })
                            .catch((err) => {
                              console.log("leadlog", err);
                            });
                          // console.log(resp);
                          dismissLoader();
                          returnRes(true);
                          successTost("Added site visit successfully!");
                          handleClose();
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }
                  } else {
                    console.error();
                    errorTost("Something went Wrong! Try Again");
                  }
                }).catch((err) => {
                  console.error("sus-add-site-visit", err)
                });
              }).catch((err) => {
                console.error("Add-kyc-doc-err", err)
              });
            } else {
              //*Optional Kyc
              let SiteVisitData = {
                leadId: LeadID,
                dateTime: Date.now(),
                photoUrl: "",
                projectId: ProjectId,
                kycId: null,
                cpId: CpID ? CpID : null,
                fosId: FosId ? FosId : null,
                inventoryTypeId: UnitType,
                userId: UserID,
                mode: SiteVisitDetails.siteVisitMode
              };
              // console.log("SiteVisitData", SiteVisitData);
              AddSite(SiteVisitData).then((response5) => {
                if (response5) {
                  // console.log("added-response", response5);
                  if (imageBase64 !== "" || imageBase64 !== null) {
                    if (imageBase64) {
                      // console.log("imageBase64", imageBase64);
                      CaptureImageInSiteVisit(
                        imageBase64,
                        response5[0].siteVistId
                      ).then((response6) => {
                        // console.log("Capture-Image", response6);
                      }).catch((err) => {
                        console.error("leads-err-add-storage-image", err)
                      });
                    }
                    handleClose();
                    updateLeadStatus(LeadID, "Site Visit Done")
                      .then((resp) => {
                        let obj = {
                          cpId: CpID ? CpID : null,
                          fosId: FosId ? FosId : null,
                          userId: UserID,
                          leadId: LeadID,
                          leadStatus: resp[0].status,
                          message: `Site visit done by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                        };
                        addLeadLogs(obj)
                          .then((leadLog) => {
                            // console.log(leadLog);
                          })
                          .catch((err) => {
                            console.log("leadlog", err);
                          });
                        // console.log(resp);
                        dismissLoader();
                        returnRes(true);
                        successTost("Added site visit successfully!");
                        handleClose();
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                } else {
                  console.error();
                  errorTost("Something went Wrong! Try Again");
                }
              }).catch((err) => {
                console.error("sus-optional-kyc-add", err)
              });
            }
          } else {
            offlineToast();
          }
        }).catch((err) => {
          console.error("sus-Network-err", err)
        });
      }
    }

    //<------------------------------------------------------------------------------------------------------>//
    else if (modalType === "EventSiteVisit") {
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
      if (
        HelperText.isPhoneNumber === "" &&
        verified &&
        HelperText.aadharNumber === "" &&
        HelperText.panNumber === "" &&
        verifiedPhoneNumber
      ) {
        // console.log("leadId", LeadID);
        Network.getStatus().then((status) => {
          if (status.connected) {
            if (verifiedKycDoc.docNumber !== '') {
              addKYCDoc(
                LeadID,
                verifiedKycDoc.docNumber,
                verifiedKycDoc.docName,
                verifiedKycDoc.docObject,
                verifiedKycDoc.docType
              ).then((rep) => {
                let SiteVisitData = {
                  leadId: LeadID,
                  eventId: EventId,
                  launchId: SiteVisitDetails.launchData.launchId,
                  dateTime: Date.now(),
                  photoUrl: "",
                  projectId: SiteVisitDetails.launchData.projectId.projectId,
                  kycId: rep[0].kycId,
                  cpId: CpID ? CpID : null,
                  fosId: FosId ? FosId : null,
                  inventoryTypeId: UnitType,
                  userId: UserID,
                  mode: SiteVisitDetails.siteVisitMode
                };
                // console.log("SiteVisitData", SiteVisitData);
                AddSite(SiteVisitData).then((response5) => {
                  if (response5) {
                    // console.log("added-response", response5);
                    if (imageBase64 !== "" || imageBase64 !== null) {
                      if (imageBase64) {
                        CaptureImageInSiteVisit(
                          imageBase64,
                          response5[0].siteVistId
                        ).then((response6) => {
                          // console.log("Capture-Image", response6);
                        }).catch((err) => {
                          console.error("err-add-storage-image", err)
                        });
                      }

                      handleClose();
                      updateLeadStatus(LeadID, "Site Visit Done")
                        .then((resp) => {
                          let obj = {
                            cpId: CpID ? CpID : null,
                            fosId: FosId ? FosId : null,
                            userId: UserID,
                            leadId: LeadID,
                            leadStatus: resp[0].status,
                            message: ` Site visit done for ${SiteVisitDetails.launchData.projectId.projectName} by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                          };
                          addLeadLogs(obj)
                            .then((leadLog) => {
                              // console.log(leadLog);
                            })
                            .catch((err) => {
                              console.log("leadlog", err);
                            });
                          dismissLoader();
                          // console.log(resp);
                          returnRes(true);
                          successTost("Added site visit successfully!");
                          handleClose();
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                      // successTost("Added site visit successfully!");
                    }
                  } else {
                    console.error();
                    errorTost("Something went Wrong! Try Again");
                  }
                }).catch((err) => {
                  console.error("event-site-visit-error", err)
                });
              }).catch((err) => {
                console.error("add-kyc-doc-err", err)
              });
            } else {
              //*optional kyc
              let SiteVisitData = {
                leadId: LeadID,
                eventId: EventId,
                launchId: SiteVisitDetails.launchData.launchId,
                dateTime: Date.now(),
                photoUrl: "",
                projectId: SiteVisitDetails.launchData.projectId.projectId,
                kycId: null,
                cpId: CpID ? CpID : null,
                fosId: FosId ? FosId : null,
                inventoryTypeId: UnitType,
                userId: UserID,
                mode: SiteVisitDetails.siteVisitMode
              };
              // console.log("SiteVisitData", SiteVisitData);
              AddSite(SiteVisitData).then((response5) => {
                if (response5) {
                  // console.log("added-response", response5);
                  if (imageBase64 !== "" || imageBase64 !== null) {
                    if (imageBase64) {
                      CaptureImageInSiteVisit(
                        imageBase64,
                        response5[0].siteVistId
                      ).then((response6) => {
                        // console.log("Capture-Image", response6);
                      }).catch((err) => {
                        console.error("add-image-to-storage-err", err)
                      });
                    }

                    handleClose();
                    updateLeadStatus(LeadID, "Site Visit Done")
                      .then((resp) => {
                        let obj = {
                          cpId: CpID ? CpID : null,
                          fosId: FosId ? FosId : null,
                          userId: UserID,
                          leadId: LeadID,
                          leadStatus: resp[0].status,
                          message: ` Site visit done for ${SiteVisitDetails.launchData.projectId.projectName} by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                        };
                        addLeadLogs(obj)
                          .then((leadLog) => {
                            // console.log(leadLog);
                          })
                          .catch((err) => {
                            console.log("leadlog", err);
                          });
                        dismissLoader();
                        // console.log(resp);
                        returnRes(true);
                        successTost("Added site visit successfully!");
                        handleClose();
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    // successTost("Added site visit successfully!");
                  }
                } else {
                  console.error();
                  errorTost("Something went Wrong! Try Again");
                }
              }).catch((err) => {
                console.error("event-optional-kyc-add", err)
              });
            }
          } else {
            offlineToast();
          }
        }).catch((err) => {
          console.error("event-Network-err", err)
        });
      }
    }
  }


  //*otp-verification
  function submitOtp() {
    let finalValue =
      OtpNumber.otp1 + OtpNumber.otp2 + OtpNumber.otp3 + OtpNumber.otp4;
    // console.log(finalValue, "recievedOtp", recievedOtp);
    if (+finalValue === recievedOtp) {
      setVerifiedPhoneNumber(true);
      setShowOtp(false);
      if (!kycOption) {
        setVerified(true)
      } else {
        setVerified(false)
      }
    } else {
      setOtpNumber((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesn't match.Please enter valid otp");
    }
  }

  //*if-otp-expired
  function smsTimeOut() {
    setHelperText((pre) => {
      pre.isPhoneNumber = "Otp has expired.Please resend otp";
      return { ...pre };
    });
    setShowOtp(true);
    setVerifiedPhoneNumber(false);
    setOtpTimer(true);
    setOtpNumber((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setRecievedOtp(null);
  }


  //*api-call-to-send-sms
  // function smsApiCall() {
  //   setResendButton(false);
  //   // const myTimeout = setTimeout(() => {
  //   //   setResendButton(true);
  //   // }, 180000);
  //   // clearTimeout(myTimeout);
  //   setOtpNumber((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   let firstThreeChar = SiteVisitDetails.contactNumber.substring(0, 3);
  //   // console.log(
  //   //   "SiteVisitDetails.LeadContactNumber",
  //   //   SiteVisitDetails.LeadContactNumber
  //   // );
  //   // console.log(
  //   //   "SiteVisitDetails.contactNumber",
  //   //   SiteVisitDetails.contactNumber
  //   // );
  //   let firstThreeChar1 = SiteVisitDetails.LeadContactNumber.substring(0, 3);
  //   // console.log(firstThreeChar === +91);
  //   // console.log(firstThreeChar1 === +91);
  //   if (firstThreeChar === +91 || firstThreeChar1 === +91) {
  //     setIsInterNational(false);
  //   } else {
  //     setIsInterNational(true);
  //   }
  //   setShowOtp(true);
  //   let body = {
  //     number:
  //       modalType === "leadSiteVisit"
  //         ? SiteVisitDetails.contactNumber
  //         : SiteVisitDetails.LeadContactNumber,
  //     isInterNational: isInterNational,
  //     email: data?.leademail
  //   };
  //   // console.log(body);
  //   sendOTPMessage(body)
  //     .then((resp) => {
  //       if (resp.data.success) {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         setRecievedOtp(parseInt(originalText));
  //         console.log("Add Site Visit OTP", parseInt(originalText));
  //         // 900000 ;15 min
  //         const myTimeout = setTimeout(smsTimeOut, 900000);
  //       } else {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         setRecievedOtp(parseInt(originalText));
  //         // console.log("Add Lead OTP", parseInt(originalText));
  //         if (resp?.data?.error?.ErrorMessage) {
  //           errorTost(resp?.data?.error?.ErrorMessage);
  //         } else {
  //           errorTost("Something went wrong");
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       // console.log(err.message);
  //     });
  // }
function smsApiCall() {
  setResendButton(false);

  // Reset OTP inputs
  setOtpNumber({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });

  // Get the current phone number based on modal type
  const activePhone =
    modalType === "leadSiteVisit"
      ? SiteVisitDetails.contactNumber
      : SiteVisitDetails.LeadContactNumber;

  // ✅ FIX: Define local variable for correct flag (not using stale state)
  const isInternationalNumber = !activePhone?.startsWith("+91");

  // Optional: still update your component state for use elsewhere
  setIsInterNational(isInternationalNumber);

  // Show OTP UI
  setShowOtp(true);

  // Request body
  let body = {
    number: activePhone,
    isInterNational: isInternationalNumber, // ✅ correct local variable
    email: data?.leademail,
  };

  // Send the OTP
  sendOTPMessage(body)
    .then((resp) => {
      // console.log("Full OTP Response:", resp);

      if (resp.data) {
        // console.log("Response data:", resp.data);

        // Step 1: Base64 decode
        const encryptedBase64 = resp.data.otp;
        const encrypted = atob(encryptedBase64);
        // console.log("Ciphertext after atob:", encrypted);

        // Step 2: AES Decrypt
        const bytes = CryptoJS.AES.decrypt(encrypted, "hts secret key");
        const originalText = bytes.toString(CryptoJS.enc.Utf8);

        if (!originalText) {
          console.error("❌ Decryption failed");
          errorTost("OTP decryption failed, please try again.");
          return;
        }

        // console.log("Decrypted OTP:", parseInt(originalText));
        setRecievedOtp(parseInt(originalText));

        // Set timeout for OTP expiry (15 min)
        setTimeout(smsTimeOut, 900000);

        // Show error if SMS failed (only for Indian numbers)
        if (!resp.data.success && !isInternationalNumber) {
          if (resp?.data?.error?.ErrorMessage) {
            errorTost(resp.data.error.ErrorMessage);
          } else {
            errorTost("Something went wrong while sending SMS");
          }
        }
      }
    })
    .catch((err) => {
      console.error("sendOTPMessage error:", err.message);
      errorTost("Failed to send OTP. Please try again.");
    });
}

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      setResendButton(true);
      // Render a completed state
      return console.log("done");
    } else {
      return (
        <span>
          {" "}
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };
  const inputfocus = (elmnt) => {
    // console.log(elmnt);
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      // console.log("next");
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
      }
    }
  };
  function optChange(value1, event) {
    // console.log(value1, event);
    event.preventDefault();
    setOtpNumber((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.HeaderTitle} mt={1}>
                  Add Site Visit
                </Box>{" "}
              </Box>
              <Box
                ml={"auto"}
                mt={1}
                onClick={CancelClose}
                style={{ cursor: "pointer" }}
              >
                <Close width={"1.2rem"} height={"1.2rem"} />
              </Box>
            </Box>
          </Box>

          <MobileStepper
            variant=""
            steps={1}
            position="static"
            activeStep={activeStep}
          />
          <Box width={"100%"} height={"80%"} overflow={"auto"}>
            <Box margin={"1.5rem 3.2rem"}>
              {activeStep === 0 && (
                <Box>
                  {modalType === "EventSiteVisit" && (
                    <Box style={{ marginBottom: "2rem" }}>
                      <Box
                        className={cssClasses.title}
                        style={{ marginBottom: "1rem" }}
                      >
                        Event Details
                      </Box>
                      <Box className={cssClasses.wrapperBlock1}>
                        <Box className={cssClasses.wrapperBlock2}>
                          <Box>
                            <div className={cssClasses.blockLabel}>
                              Select Event
                              <span style={{ color: "red" }}> *</span>
                            </div>
                            <div>
                              {modalType === "EventSiteVisit" && (
                                <Box>
                                  <CustomInput
                                    value={EventName}
                                    disabled={true}
                                  />
                                </Box>
                              )}

                              {modalType !== "EventSiteVisit" && (
                                <DropDown
                                  list={EventList.map((element, id) => {
                                    return {
                                      label: element.title,
                                      value: element.title,
                                    };
                                  })}
                                  selectedValue={SiteVisitDetails.eventTitle}
                                  onChangeSelect={(value) => {
                                    setSiteVisitDetails((pre) => {
                                      pre.eventTitle = value;
                                      return { ...pre };
                                    });

                                    setHelperText((pre) => {
                                      pre.eventName = "";
                                      return { ...pre };
                                    });
                                    let selectedEvent;
                                    selectedEvent = EventList.filter(
                                      ({ title }) => value === title
                                    );
                                    // console.log(selectedEvent[0].eventId);
                                    setSiteVisitDetails((pre) => {
                                      pre.eventData = selectedEvent[0];
                                      return { ...pre };
                                    });
                                    getLaunchDetails(selectedEvent[0].eventId);
                                  }}
                                  placeHolder={"Select"}
                                  //style.color is placeHolder's color
                                  style={{
                                    background: "#F2F4F7",
                                    color: "rgb(102, 112, 133)",
                                  }}
                                  helperText={HelperText.eventName}
                                />
                              )}
                            </div>
                          </Box>
                          <Box>
                            <div className={cssClasses.blockLabel}>
                              Select Launch
                              <span style={{ color: "red" }}>*</span>
                            </div>
                            <div style={{ width: "100%" }}>
                              <DropDown
                                list={LaunchList.map((element, id) => {
                                  return {
                                    label: element.title,
                                    value: element.title,
                                  };
                                })}
                                selectedValue={SiteVisitDetails.launchTitle}
                                onChangeSelect={(value) => {
                                  setSiteVisitDetails((pre) => {
                                    pre.launchTitle = value;
                                    return { ...pre };
                                  });

                                  setHelperText((pre) => {
                                    pre.launchName = "";
                                    return { ...pre };
                                  });
                                  let selectedLaunch;
                                  selectedLaunch = LaunchList.filter(
                                    ({ title }) => value === title
                                  );
                                  setSiteVisitDetails((pre) => {
                                    pre.launchData = selectedLaunch[0];
                                    return { ...pre };
                                  });
                                  // console.log("selectedLaunch[0]" ,selectedLaunch[0]);
                                  getUnitTypeDetails(
                                    selectedLaunch[0].projectId.projectId
                                  );
                                  // console.log("selectedLaunch[0].projectId.panVerificationForSiteVisit" , selectedLaunch[0].projectId.panVerificationForSiteVisit)
                                  setKycOtption(selectedLaunch[0].projectId.panVerificationForSiteVisit)
                                }}
                                placeHolder={"Select"}
                                //style.color is placeHolder's color
                                style={{
                                  background: "#F2F4F7",
                                  color: "rgb(102, 112, 133)",
                                }}
                                helperText={HelperText.launchName}
                              />
                            </div>
                          </Box>
                        </Box>
                        <Box>
                          <div className={cssClasses.blockLabel}>
                            Select Unit Type
                            <span style={{ color: "red" }}> *</span>
                          </div>
                          <div style={{ width: "100%" }}>
                            <DropDown
                              placeHolder={"Select"}
                              list={InventoryType.map((m) => m.inventoryTypeId)
                                .reduce((arr, ele) => {
                                  if (
                                    !arr.some(
                                      (s) =>
                                        s.inventoryTypeId ===
                                        ele.inventoryTypeId
                                    )
                                  ) {
                                    arr.push(ele);
                                  }
                                  return arr;
                                }, [])
                                .map((m) => ({
                                  label: m.type,
                                  value: m.inventoryTypeId,
                                }))}
                              selectedValue={SiteVisitDetails.unitId}
                              onChangeSelect={(value) => {
                                setSiteVisitDetails((pre) => {
                                  pre.unitId = value;
                                  // console.log("value", value);
                                  // console.log("Unit-Type", UnitType);
                                  return { ...pre };
                                });
                                setUnitType(value);

                                if (SiteVisitDetails.unitId !== "") {
                                  HelperText.UnitTypeName = "";
                                } else {
                                  HelperText.UnitTypeName =
                                    "Please select unitType";
                                }
                              }}
                              style={{
                                background: "#F2F4F7",
                                selectedColor: "#667085",
                              }}
                              helperText={HelperText.UnitTypeName}
                            />
                          </div>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {modalType === "leadSiteVisit" && (
                    <Box style={{ marginBottom: "2rem" }}>
                      <Box className={cssClasses.wrapperBlock1}>
                        <Box className={cssClasses.wrapperBlock2}>
                          <Box>
                            <div className={cssClasses.blockLabel}>
                              Select Project
                              <span style={{ color: "red" }}> *</span>
                            </div>
                            <div>
                              <DropDown
                                list={projectList.map((element, id) => {
                                  return {
                                    label: element.projectName,
                                    value: element.projectId,
                                  };
                                })}
                                disable={multipleSiteVisit}
                                selectedValue={SiteVisitDetails.projectId}
                                onChangeSelect={(value) => {
                                  let selectedProject = projectList.filter(
                                    ({ projectId }) => projectId === value
                                  );
                                  setSiteVisitDetails((pre) => {
                                    pre.projectId = value;
                                    pre.projectName =
                                      selectedProject[0].projectName;
                                    pre.selectedProjectData = selectedProject[0];

                                    return { ...pre };
                                  });
                                  setKycOtption(selectedProject[0].panVerificationForSiteVisit);
                                  setHelperText((pre) => {
                                    pre.projectId = "";
                                    return { ...pre };
                                  });
                                }}
                                placeHolder={"Select"}
                                //style.color is placeHolder's color
                                style={{
                                  background: "#F2F4F7",
                                  color: "rgb(102, 112, 133)",
                                }}
                                helperText={HelperText.projectId}
                              />
                            </div>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  <Box>
                    <Box className={cssClasses.title}>Site Visit Details</Box>
                    <Box className={cssClasses.UnitDiv}>
                      {(modalType === "SustenanceSiteVisit" ||
                        modalType === "EventSiteVisit") && (
                          <Box margin={"1rem 0"}>
                            {modalType !== "EventSiteVisit" && (
                              <Box className={cssClasses.widthBox}>
                                <Box className={cssClasses.InputTitle}>
                                  Unit Type{" "}
                                  <span className={cssClasses.Star}>*</span>
                                </Box>
                                <DropDown
                                  placeHolder={"Select"}
                                  list={InventoryType.map(
                                    (m) => m.inventoryTypeId
                                  )
                                    .reduce((arr, ele) => {
                                      if (
                                        !arr.some(
                                          (s) =>
                                            s.inventoryTypeId ===
                                            ele.inventoryTypeId
                                        )
                                      ) {
                                        arr.push(ele);
                                      }
                                      return arr;
                                    }, [])
                                    .map((m) => ({
                                      label: m.type,
                                      value: m.inventoryTypeId,
                                    }))}
                                  selectedValue={SiteVisitDetails.UnitType}
                                  onChangeSelect={(value) => {
                                    setSiteVisitDetails((pre) => {
                                      pre.UnitType = value;
                                      // console.log("value", value);
                                      setUnitType(value);
                                      // console.log("Unit-Type", UnitType);
                                      return { ...pre };
                                    });
                                    if (SiteVisitDetails.UnitType !== "") {
                                      HelperText.UnitType = "";
                                    } else {
                                      HelperText.UnitType =
                                        "Please select unitType";
                                    }
                                  }}
                                  style={{
                                    background: "#F2F4F7",
                                    selectedColor: "#667085",
                                  }}
                                  helperText={HelperText.UnitType}
                                />
                              </Box>
                            )}
                            <Box margin={"1rem 0"}>
                              <Box className={cssClasses.InputTitle}>
                                Lead Name or Lead ID{" "}
                                <span className={cssClasses.Star}>*</span>
                              </Box>
                              <Box className={cssClasses.widthBox}>
                                <CustomAutoComplete
                                  value={LeadValue}
                                  InitialValue={setLeadValue}
                                  SecondInputValue={LeadName}
                                  OnInputChange={(e, inputValue) => {
                                    setSiteVisitDetails((pre) => {
                                      pre.leadName = inputValue;
                                      OnChangeOfLeadName(inputValue);
                                      return { ...pre };
                                    });

                                    if (SiteVisitDetails.leadName !== "") {
                                      HelperText.leadName = "";
                                    } else {
                                      HelperText.leadName = "Please select Lead";
                                    }

                                    // console.log("Lead-Value" , LeadValue)
                                    // console.log("LeadName" , LeadName)
                                  }}
                                  disable={false}
                                  list={AllLeads.map((m) => ({
                                    label: `${m.personId?.name} - ${m.leadDisplayId}`,
                                    name: m?.cpId?.billingName
                                      ? m?.cpId?.billingName
                                      : "",
                                  }))}
                                  NoOptionsText={"No Leads Found"}
                                  getOptionLabel={(lead) => lead.label || ""}
                                  renderOption={(props, SecondInputValue) => (
                                    <Box
                                      display={"flex"}
                                      flexDirection={"column"}
                                    >
                                      <Box {...props} key={SecondInputValue.id}>
                                        <Box
                                          component={"span"}
                                          style={{
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {SecondInputValue.label}
                                        </Box>
                                      </Box>
                                      {/* <Box ml={1}>CP:{SecondInputValue.name ? SecondInputValue.name : "-" }</Box> */}
                                    </Box>
                                  )}
                                  helperText={HelperText.leadName}
                                />
                              </Box>
                            </Box>

                            {(leadType === false && LeadName !== "") && (
                              <>
                                <Box margin={"2rem 0"}>
                                  <Box className={cssClasses.InputTitle}>
                                    Channel partner{" "}
                                    <span className={cssClasses.Star}>*</span>
                                  </Box>
                                  <Box className={cssClasses.widthBox}>
                                    <Box className={cssClasses.outerBox}>
                                      <p className={cssClasses.readFieldBox}>
                                        {CpName}
                                      </p>
                                    </Box>
                                  </Box>
                                </Box>

                                {CpType === "Entity" && (
                                  <Box margin={"2rem 0"}>
                                    <Box className={cssClasses.InputTitle}>
                                      FOS{" "}
                                      <span className={cssClasses.Star}>*</span>
                                    </Box>
                                    {FosData?.length === 1 && (
                                      <Box className={cssClasses.widthBox}>
                                        <Box className={cssClasses.outerBox}>
                                          <p className={cssClasses.readFieldBox}>
                                            {FosData[0]?.name}
                                          </p>
                                        </Box>
                                      </Box>
                                    )}

                                    {FosData?.length > 1 && (
                                      <DropDown
                                        placeHolder={"Select"}
                                        list={FosData.map((ele, id) => {
                                          return {
                                            label: ele.name,
                                            value: ele.fosId,
                                          };
                                        })}
                                        selectedValue={
                                          SiteVisitDetails.EntityType
                                        }
                                        onChangeSelect={(value) => {
                                          setSiteVisitDetails((pre) => {
                                            pre.EntityType = value;
                                            setEntityFos(value);
                                            // console.log("Enittttty", EntityFos);
                                            return { ...pre };
                                          });
                                          if (
                                            SiteVisitDetails.EntityType !== ""
                                          ) {
                                            HelperText.EntityType = "";
                                          } else {
                                            HelperText.EntityType =
                                              "Please select entity Name";
                                          }
                                        }}
                                        style={{
                                          background: "#F2F4F7",
                                          selectedColor: "#667085",
                                        }}
                                        helperText={HelperText.EntityType}
                                      />
                                    )}
                                  </Box>
                                )}
                              </>
                            )}

                            <Box margin={"2rem 0"}>
                              <Box className={cssClasses.InputTitle}>
                                Sales Manager{" "}
                                <span className={cssClasses.Star}>*</span>
                              </Box>
                              <Box className={cssClasses.widthBox}>
                                <CustomAutoComplete
                                  value={UserValue}
                                  getOptionDisabled={true}
                                  InitialValue={setUserValue}
                                  SecondInputValue={UserName}
                                  OnInputChange={(e, inputValue) => {
                                    setSiteVisitDetails((pre) => {
                                      pre.UserName = inputValue;
                                      OnChangeOfUserName(inputValue);
                                      return { ...pre };
                                    });
                                    if (SiteVisitDetails.UserName !== "") {
                                      HelperText.UserName = "";
                                    } else {
                                      HelperText.UserName =
                                        "Please select Sales Manager";
                                    }
                                  }}
                                  disable={false}
                                  list={AllUsers}
                                  NoOptionsText={"No Managers Found"}
                                  getOptionLabel={(user) => user.name || ""}
                                  renderOption={(props, SecondInputValue) => (
                                    <Box
                                      component={"li"}
                                      {...props}
                                      key={SecondInputValue.id}
                                    >
                                      <Box
                                        component={"span"}
                                        className={cssClasses.textWrapper}
                                      >
                                        {SecondInputValue.name}
                                      </Box>
                                    </Box>
                                  )}
                                  helperText={HelperText.UserName}
                                />
                              </Box>
                            </Box>
                            <Box margin={"1rem 0"}>
                              <Box className={cssClasses.InputTitle}>
                                Lead contact{" "}
                                <span className={cssClasses.Star}>*</span>
                              </Box>
                              <Box className={cssClasses.widthBox}>
                                <CustomInput
                                  value={SiteVisitDetails.LeadContactNumber}
                                  handleChange={(_value) => {
                                    const r = new RegExp(/^\d+$/);
                                    if (
                                      (r.test(_value) || _value === "") &&
                                      _value.length <= 10
                                    ) {
                                      let pre = Object.assign(
                                        {},
                                        SiteVisitDetails
                                      );
                                      pre.LeadContactNumber = _value;
                                      setSiteVisitDetails((pre) => {
                                        pre.LeadContactNumber = _value;
                                        // console.log("LeadContactNumber", _value);
                                        setLeadContact({ ...pre });
                                        return { ...pre };
                                      });
                                    }
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                        )}
                      {modalType === "leadSiteVisit" && (
                        <Fragment>
                          <Box margin={"1rem 0"}>
                            <Box margin={"0rem 0rem 1rem 0rem"}>
                              <Box className={cssClasses.InputTitle}>
                                Lead Name{" "}
                                {/* <span className={cssClasses.Star}>*</span> */}
                              </Box>
                              <Box className={cssClasses.widthBox}>
                                <CustomInput
                                  value={data.person.name}
                                  disabled={true}
                                  inputType={"Disabled"}
                                />
                              </Box>
                            </Box>
                            {data.CP.name !== "-" && (
                              <Box margin={"0rem 0rem 1rem 0rem"}>
                                <Box className={cssClasses.InputTitle}>
                                  Channel Partner{" "}
                                  {/* <span className={cssClasses.Star}>*</span> */}
                                </Box>
                                <Box className={cssClasses.widthBox}>
                                  <CustomInput
                                    value={data.CP.name}
                                    disabled={true}
                                  />
                                </Box>
                              </Box>
                            )}

                            {data.FOS.name !== "-" && (
                              <Box margin={"2rem 0"}>
                                <Box className={cssClasses.InputTitle}>
                                  FoS Name
                                  <span className={cssClasses.Star}>*</span>
                                </Box>
                                <DropDown
                                  placeHolder={"Select"}
                                  list={FosData.map((ele, id) => {
                                    return {
                                      label: ele.name,
                                      value: ele.name,
                                    };
                                  })}
                                  selectedValue={SiteVisitDetails.fosName}
                                  onChangeSelect={(value) => {
                                    // console.log(value);
                                    setSiteVisitDetails((pre) => {
                                      pre.fosName = value;
                                      return { ...pre };
                                    });
                                    let selectedFos;
                                    selectedFos = FosData.filter(
                                      ({ name }) => value === name
                                    );
                                    // console.log(selectedFos);
                                    setSiteVisitDetails((pre) => {
                                      pre.fosId = selectedFos[0].fosId;
                                      return { ...pre };
                                    });
                                  }}
                                // style={{
                                //   background: "#F2F4F7",
                                //   selectedColor: "#175CD3",
                                // }}
                                />
                              </Box>
                            )}
                            <Box margin={"2rem 0"}>
                              <Box className={cssClasses.InputTitle}>
                                Sales Manager
                                <span className={cssClasses.Star}>*</span>
                              </Box>
                              <Box className={cssClasses.widthBox}>
                                <CustomAutoComplete
                                  value={UserValue}
                                  InitialValue={setUserValue}
                                  SecondInputValue={UserName}
                                  OnInputChange={(e, inputValue) => {
                                    setSiteVisitDetails((pre) => {
                                      pre.UserName = inputValue;
                                      OnChangeOfUserName(inputValue);
                                      return { ...pre };
                                    });
                                    if (SiteVisitDetails.UserName !== "") {
                                      HelperText.UserName = "";
                                    } else {
                                      HelperText.UserName =
                                        "Please select Sales Manager";
                                    }
                                  }}
                                  disable={true}
                                  list={AllUsers}
                                  NoOptionsText={"No Managers Found"}
                                  getOptionLabel={(user) =>
                                    user.name || data.Sales.name || ""
                                  }
                                  renderOption={(props, SecondInputValue) => (
                                    <Box
                                      component={"li"}
                                      {...props}
                                      key={SecondInputValue.id}
                                    >
                                      <Box
                                        component={"span"}
                                        className={cssClasses.textWrapper}
                                      >
                                        {SecondInputValue.name}
                                      </Box>
                                    </Box>
                                  )}
                                  helperText={HelperText.UserName}
                                />
                              </Box>
                            </Box>
                            <Box>
                              <Box className={cssClasses.InputTitle}>
                                Site Visit Mode
                                {/* <span className={cssClasses.Star}>*</span> */}
                              </Box>
                              <DropDown
                                placeHolder={"Select"}
                                list={["Video Call", "Onsite", "F2F"]}
                                selectedValue={SiteVisitDetails.siteVisitMode}
                                onChangeSelect={(value) => {
                                  setSiteVisitDetails((pre) => {
                                    pre.siteVisitMode = value;
                                    return { ...pre };
                                  });
                                }}
                                style={{
                                  background: "#F2F4F7",
                                  selectedColor: "#667085",
                                }}
                              />
                            </Box>
                            {loggedInUser?.roleId?.accessibleTabs?.Leads?.[
                              "Edit SiteVisit Date"
                            ]?.isAccessible && (
                                <Box margin={"2rem 0"}>
                                  <Box className={cssClasses.InputTitle}>
                                    Site Visit On
                                    <span className={cssClasses.Star}>*</span>
                                  </Box>
                                  <DateComponent
                                    value={SiteVisitDetails.dateTime}
                                    onChangeDate={(value) => {
                                      setSiteVisitDetails((pre) => {
                                        pre.dateTime = value;
                                        return { ...pre };
                                      });
                                    }}
                                    helperText={""}
                                  />
                                </Box>
                              )}
                            <Box margin={"2rem 0"}>
                              <Box className={cssClasses.InputTitle}>
                                Remark
                              </Box>
                              <TextField
                                maxRows={4}
                                value={SiteVisitDetails.remark}
                                onChange={(e) => {
                                  e.target.value = e.target.value.trimStart();
                                  if (e.target.value.length <= 200) {
                                    setSiteVisitDetails((pre) => {
                                      pre.remark = e.target.value;
                                      return { ...pre };
                                    });
                                  }
                                }}
                                placeholder={"Type..."}
                                className={classes.TextFieldStyle}
                                InputProps={{
                                  className: classes.inputStyle,
                                }}
                                inputProps={{ min: 0 }}
                                multiline
                              />
                            </Box>
                          </Box>
                        </Fragment>
                      )}

                      <Box margin={"2.3rem 0"}>
                        <Box className={cssClasses.InputTitle} mb={2}>
                          Lead Photo
                          <span className={cssClasses.Star}>*</span>
                        </Box>
                        <Box>
                          <CameraCapture
                            CapturePhoto={() => setWebCamModalToggler(true)}
                            WebCamOpen={webCamModalToggler}
                            HandleCaptureClose={() =>
                              setWebCamModalToggler(false)
                            }
                            InitialData={imageBase64}
                            UploadedData={(_v) => {
                              // console.log({ _v });
                              setImageBase64(_v);
                            }}
                            SaveData={SavingImageData}
                            siteVist={true}
                            uploadPhotoAccess={
                              loggedInUser?.roleId?.accessibleTabs?.Leads?.[
                                "Upload Option SiteVisit"
                              ]?.isAccessible

                              ||
                              loggedInUser?.roleId?.accessibleTabs?.Sustenance?.[
                                "Site Visit"
                              ]?.["Add Site Visit"]?.isAccessible ||
                              loggedInUser?.roleId?.accessibleTabs?.Event?.[
                                "View Details"
                              ]?.["Site Visit"]?.["Add Site Visit"]?.isAccessible
                            }
                          />
                        </Box>

                        {/* <Box style={{marginTop:'1rem'}}>
                          {loggedInUser?.roleId?.accessibleTabs?.Leads?.["Upload Option SiteVisit"].isAccessible && (
                            <Box
                              className={cssClasses.uploadInput}
                              onClick={() => {
                                document.getElementById("imgupload").click();
                              }}
                              
                            >
                              <input
                                hidden
                                type="file"
                                accept="image/*"
                                id="imgupload"
                                name=""
                                onChange={(e) => {
                                  var file = e.target.files[0];
                                  let reader = new FileReader();
                                  reader.onload = (e) => {
                                    let image = e.target.result;
                                    setImageBase64(image);
                                  };
                                  reader.readAsDataURL(file);
                                  // setImageBase64(e.target.files[0]);
                                  setUploadPhoto(true);
                                  console.log(e.target.files);
                                }}
                              />
                              {(imageBase64 === "" || imageBase64 === null) && (
                                <Box className={cssClasses.InputTitle} style={{cursor:'pointer'}} mb={2}>
                                 Or Upload Lead Photo
                                </Box>
                              )}

                              {imageBase64 !== null && (
                                <div>
                                  <img
                                    src={imageBase64 ?? ""}
                                    alt="leadUploadedPhoto"
                                    id="uploadedImage"
                                    className={cssClasses.uploadedImage}
                                  ></img>
                                  <Box style={{cursor:'pointer'}} className={cssClasses.InputTitle} mb={2}>
                                    Reupload Lead Photo
                                  </Box>
                                </div>
                              )}
                            </Box>
                          )}
                        </Box> */}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}

              {activeStep === 1 && (
                <>
                  <Box mt={4}>
                    <Box className={cssClasses.flexRow1}>
                      <Box width={"fit-Content"}>
                        <Button
                          style={{
                            fontSize: "1.6rem",
                            lineHeight: "2.4rem",
                            color: "#000000",
                            backgroundColor: "#FFFFFF",
                            border: "none",
                            boxShadow: "none",
                          }}
                          padding={"0"}
                          btnIcon={
                            <ArrowBack
                              style={{
                                width: "1.9rem",
                                height: "1.9rem",
                                color: "#000000",
                                marginTop: "0.5rem",
                              }}
                            />
                          }
                          iconPosition={"left"}
                          btnName={""}
                          clicked={() => goBack()}
                        />
                      </Box>
                      <Box className={cssClasses.title}>Verification</Box>
                    </Box>

                    <Box className={cssClasses.SecondStepper}>
                      <Box
                        display={"flex"}
                        flexDirection={"column"}
                        flexWrap={"nowrap"}
                        gap={"2rem"}
                      >
                        <Box mt={2}>
                          <Box style={{ position: "relative" }}>
                            <Box className={cssClasses.InputTitle} mb={1}>
                              Phone Number{" "}
                              <span className={cssClasses.Star}>*</span>
                            </Box>
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              gap={"1.2rem"}
                              flexWrap={"wrap"}
                            >
                            <Box width={"fit-Content"}>
                              <PhoneInput
                                defaultCountry="IN"
                                value={
                                  modalType === "leadSiteVisit"
                                    ? `${SiteVisitDetails.contactNumber}`
                                    : `${SiteVisitDetails.LeadContactNumber}`
                                }
                                //  disabled={SiteVisitDetails.disabledPhoneNumber}
                                disabled={
                                  showOtp || verifiedPhoneNumber || resendButton
                                }
                                placeholder="Enter phone number"
                                onChange={(phone) => {
                                  // console.log(phone);

                                  if (phone !== undefined) {
                                    if (phone.length >= 1) {
                                      if (isValidPhoneNumber(phone) === false) {
                                        HelperText.isPhoneNumber = `Please Enter valid Phone Number`;
                                        setShowOtp(false);
                                        setVerifiedPhoneNumber(false);
                                      } else {
                                        HelperText.isPhoneNumber = "";
                                        // console.log(phone);
                                        IsNumberBlackListed(phone);
                                      }
                                    }
                                  } else {
                                    HelperText.isPhoneNumber =
                                      "Please Enter Phone Number";
                                    setShowOtp(false);
                                    setVerifiedPhoneNumber(false);
                                  }
                                  if (modalType === "leadSiteVisit") {
                                    setSiteVisitDetails((pre) => {
                                      pre.contactNumber = phone;
                                      return { ...pre };
                                    });
                                  } else {
                                    setSiteVisitDetails((pre) => {
                                      pre.LeadContactNumber = phone;
                                      return { ...pre };
                                    });
                                  }
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "1.4rem",
                                  lineHeight: "1.66",
                                }}
                              >
                                {HelperText.isPhoneNumber}
                              </p>
                            </Box>

                            <Box>
                              {HelperText.isPhoneNumber === "" &&
                                verifiedPhoneNumber === false &&
                                otptimer === false &&
                                showOtp === false &&
                                (SiteVisitDetails.contactNumber !== "" ||
                                  SiteVisitDetails.LeadContactNumber !==
                                  "") && (
                                  <Box
                                    className={cssClasses.verifyOtp}
                                    onClick={() => {
                                      setShowOtp(true);
                                      smsApiCall();
                                      // sendSms('9130764955',personDetail.phoneNumber).then((res)=>{
                                      //   console.log(res);
                                      // }).catch((err)=>{
                                      //   console.log(err);
                                      // })
                                    }}
                                  >
                                    Verify Otp
                                  </Box>
                                )}
                              {verifiedPhoneNumber === false &&
                                showOtp === true &&
                                resendButton === true && (
                                  <div
                                    className={cssClasses.verifyOtp}
                                    onClick={() => {
                                      setHelperText((pre) => {
                                        pre.isPhoneNumber = "";
                                        return { ...pre };
                                      });
                                      smsApiCall();
                                    }}
                                  >
                                    Resend Otp
                                  </div>
                                )}
                              {verifiedPhoneNumber === false &&
                                showOtp === true &&
                                resendButton === false && (
                                  <div className={cssClasses.resendOtp}>
                                    {" "}
                                    Resend Otp in{" "}
                                    {/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
                                    <CountdownTimer
                                      startFrom={180}
                                      onComplete={() => {
                                        setResendButton(true);
                                      }}
                                      timeFormatter={(time) => {
                                        return (
                                          <span>
                                            {`0${Math.floor(time / 60)}`.slice(
                                              -2
                                            )}
                                            :{`0${time % 60}`.slice(-2)}
                                          </span>
                                        );
                                      }}
                                    />
                                  </div>
                                )}
                              {HelperText.isPhoneNumber === "" &&
                                verifiedPhoneNumber &&
                                otptimer === false && (
                                  <div className={cssClasses.verifyOtp}>
                                    <CheckCircleSharpIcon
                                      style={{
                                        fontSize: "2.5rem",
                                        marginRight: "1rem",
                                      }}
                                      color={"success"}
                                    />
                                  </div>
                                )}
                            </Box>
                            </Box>
                          </Box>
                        </Box>
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Box
                            className={cssClasses.UnitDiv}
                            width={"50%"}
                            margin={"2rem 0"}
                          >
                            {showOtp && (
                              <Box>
                                <Box className={cssClasses.InputTitle} mb={1}>
                                  OTP sent to contact:
                                </Box>
                                <Box className={cssClasses.flexRow}>
                                  <input
                                    className={cssClasses.otpInput}
                                    name="otp1"
                                    id="opt-0"
                                    type="text"
                                    autoComplete="off"
                                    value={OtpNumber.otp1}
                                    // onKeyPress={keyPressed}
                                    onChange={(e) => optChange("otp1", e)}
                                    tabIndex="0"
                                    maxLength="1"
                                    onKeyUp={(e) => inputfocus(e)}
                                  />
                                  <input
                                    name="otp2"
                                    id="opt-1"
                                    type="text"
                                    autoComplete="off"
                                    className={cssClasses.otpInput}
                                    value={OtpNumber.otp2}
                                    onChange={(e) => optChange("otp2", e)}
                                    tabIndex="1"
                                    maxLength="1"
                                    onKeyUp={(e) => inputfocus(e)}
                                  />
                                  <input
                                    name="otp3"
                                    id="opt-2"
                                    type="text"
                                    autoComplete="off"
                                    className={cssClasses.otpInput}
                                    value={OtpNumber.otp3}
                                    onChange={(e) => optChange("otp3", e)}
                                    tabIndex="2"
                                    maxLength="1"
                                    onKeyUp={(e) => inputfocus(e)}
                                  />
                                  <input
                                    name="otp4"
                                    type="text"
                                    id="opt-3"
                                    autoComplete="off"
                                    className={cssClasses.otpInput}
                                    value={OtpNumber.otp4}
                                    onChange={(e) => optChange("otp4", e)}
                                    tabIndex="3"
                                    maxLength="1"
                                    onKeyUp={(e) => inputfocus(e)}
                                  />
                                </Box>
                                <Box width={"fit-Content"} mt={2}>
                                  <Button
                                    tabIndex={4}
                                    style={{
                                      fontSize: "1.6rem",
                                      lineHeight: "2.4rem",
                                      color: "#ffffff",
                                      backgroundColor: "#155EEF",
                                      borderRadius: "1rem",
                                    }}
                                    padding={"0.8rem 1.1rem"}
                                    btnName={"Verify OTP"}
                                    clicked={submitOtp}
                                  />
                                </Box>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Box>
                      {multipleSiteVisit === false && (
                        <Box
                          display={"flex"}
                          flexDirection={"column"}
                          flexWrap={"nowrap"}
                          gap={"2rem"}
                        >
                          <Box>
                            <Box mt={2}>
                              <Box className={cssClasses.InputTitle} mb={1.5}>
                                Verification{" "}
                                {kycOption &&
                                  (
                                    <span className={cssClasses.Star}>*</span>
                                  )}
                              </Box>
                              <Box width={"34rem"}>
                                <DropDown
                                  placeHolder={"Select"}
                                  list={VerificationType}
                                  selectedValue={VerificationTypeValue}
                                  style={{
                                    background: "#F2F4F7",
                                    selectedColor: "#667085",
                                  }}
                                  onChangeSelect={(_value) => {
                                    setVerifyPan(false);
                                    setVerifyAadhar(false);
                                    setVerified(false);
                                    setHelperText((pre) => {
                                      pre.panNumber = "";
                                      pre.aadharNumber = "";
                                      pre.isAadharValid = false;
                                      pre.isPanValid = false;
                                      return { ...pre };
                                    });
                                    setPanNumber("");
                                    setAadharNumber("");
                                    setVerifiedKycDoc((pre) => {
                                      pre.docNumber = "";
                                      pre.docType = "";
                                      pre.docName = "";
                                      pre.docObject = null;
                                      return { ...pre };
                                    });
                                    setSiteVisitDetails((pre) => {
                                      pre.isAadharValid = false;
                                      pre.isPanValid = false;
                                      pre.panNumber = "";
                                      pre.aadharNumber = "";
                                      return { ...pre };
                                    });
                                    setVerificationTypeValue(_value);
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                          <Box mt={2}>
                            {VerificationTypeValue === "PAN Verification" && (
                              <Box marginLeft={"auto"}>
                                <Box className={cssClasses.InputTitle}>
                                  PAN Number :{" "}
                                </Box>
                                <Box className={cssClasses.widthBox}>
                                  <CustomInput
                                    placeholder={"Enter PAN Number"}
                                    value={panNumber}
                                    handleChange={(newValue) => {
                                      setVerified(false);
                                      setVerifyAadhar(true);
                                      setVerifyPan(true);
                                      newValue = newValue.trim();
                                      newValue = newValue.toUpperCase();
                                      var regex =
                                        /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                                      if (!regex.test(newValue)) {
                                        HelperText.isPanValid = false;
                                        setPanName("");
                                        HelperText.panNumber =
                                          "Please enter Valid PAN number.";
                                      } else {
                                        HelperText.panNumber = "verifying...";
                                        if (newValue.length === 10) {
                                          setIsLoadingPan(true);
                                          PAN_CardCheck(newValue.toUpperCase());
                                        }
                                      }
                                      if (newValue.length === 0 && kycOption === false) {
                                        setVerified(true);
                                        HelperText.panNumber =
                                          "";
                                      }
                                      if (newValue.length <= 10) {
                                        setPanNumber(newValue);
                                      }
                                    }}
                                    helperText={HelperText.panNumber}
                                    isLoading={isLoadingPan}
                                    greenTick={HelperText.isPanValid}
                                  />
                                </Box>
                                {verified === false && (
                                  <Box width={"fit-Content"} mt={2}>
                                    <Button
                                      style={{
                                        fontSize: "1.6rem",
                                        lineHeight: "2.4rem",
                                        color: "#ffffff",
                                        backgroundColor: "#155EEF",
                                      }}
                                      btnName={"Verify"}
                                      disable={VerifyPan}
                                      clicked={PanVerify}
                                    />
                                  </Box>
                                )}
                              </Box>
                            )}

                            {VerificationTypeValue ===
                              "Aadhar Verification" && (
                                <Box marginLeft={"auto"}>
                                  <Box className={cssClasses.InputTitle}>
                                    Aadhar Number :{" "}
                                  </Box>
                                  <Box className={cssClasses.widthBox}>
                                    <CustomInput
                                      placeholder={"Enter Aadhar Number"}
                                      value={SiteVisitDetails.aadharNumber}
                                      handleChange={(newValue) => {
                                        newValue = newValue.trim();
                                        newValue = newValue.toUpperCase();
                                        var numbers = /^[0-9]*$/;
                                        if (
                                          newValue.match(numbers) ||
                                          newValue === ""
                                        ) {
                                          if (newValue.length <= 12) {
                                            setSiteVisitDetails((pre) => {
                                              pre.aadharNumber = newValue;
                                              return Object.assign({}, pre);
                                            });
                                          }
                                          if (newValue.length === 12) {
                                            HelperText.aadharNumber =
                                              "verifying...";
                                            setIsLoadingAadhar(true);
                                            AADHAR_CardCheck(
                                              newValue.toUpperCase()
                                            );
                                            setAadharNumber(newValue);
                                          } else {
                                            HelperText.isAadharValid = false;
                                            setVerified(false);
                                            setVerifyAadhar(true);
                                            HelperText.aadharNumber =
                                              "Please Enter valid Aadhar number.";
                                          }
                                        }
                                      }}
                                      helperText={HelperText.aadharNumber}
                                      isLoading={isLoadingAadhar}
                                      greenTick={HelperText.isAadharValid}
                                    />
                                  </Box>
                                  {verified === false && (
                                    <Box width={"fit-Content"} mt={2}>
                                      <Button
                                        style={{
                                          fontSize: "1.6rem",
                                          lineHeight: "2.4rem",
                                          color: "#ffffff",
                                          backgroundColor: "#155EEF",
                                        }}
                                        btnName={"Verify"}
                                        disable={VerifyAadhar}
                                        clicked={AadharVerify}
                                      />
                                    </Box>
                                  )}
                                </Box>
                              )}
                          </Box>
                        </Box>
                      )}

                      {modalType === "leadSiteVisit" && (
                        <Box
                          display={"flex"}
                          flexDirection={"column"}
                          gap={"2rem"}
                          mt={4}
                        >
                          <Box>
                            <Box className={cssClasses.InputTitle}>
                              Start Date &amp; Time
                            </Box>
                            {/* Locked to the current date & time when the modal opened — not editable */}
                            <DateComponent
                              value={siteVisitStart}
                              disabled={true}
                              onChangeDate={() => {}}
                              helperText={dateTimeError.start}
                            />
                          </Box>
                          <Box>
                            <Box className={cssClasses.InputTitle}>
                               End Time
                              <span className={cssClasses.Star}>*</span>
                            </Box>
                            {/* Time-only picker — no calendar shown; date always stays today. */}
                            <EndTimePicker
                              value={siteVisitEnd}
                              helperText={dateTimeError.end}
                              onChangeTime={(value) => {
                                if (!value) {
                                  setSiteVisitEnd(null);
                                } else {
                                  // Keep today's date, take only the selected time part.
                                  const picked = dayjs(value);
                                  const todayWithTime = dayjs()
                                    .hour(picked.hour())
                                    .minute(picked.minute())
                                    .second(0)
                                    .millisecond(0);
                                  setSiteVisitEnd(todayWithTime.toDate());
                                }
                                setDateTimeError((pre) => ({
                                  ...pre,
                                  end: "",
                                }));
                              }}
                            />
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={"fit-Content"} ml={"auto"}>
                <Button
                  style={{
                    color: "#344054",
                    backgroundColor: "#ffffff",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  padding={"0.85rem 2.6rem"}
                  btnName={"Cancel"}
                  clicked={CancelClose}
                />
              </Box>

              <Box width={"fit-Content"}>
                {activeStep === 0 && (
                  <Button
                    style={{
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                      color: "#FFF",
                      backgroundColor: "#155EEF",
                    }}
                    padding={"0.85rem 3.2rem"}
                    btnName={"Next"}
                    clicked={AddSiteVisitData}
                  />
                )}
                {activeStep === 1 && (
                  <Button
                    style={{
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                      color: "#ffffff",
                      backgroundColor: "#155EEF",
                    }}
                    disable={verified === false}
                    btnName={"Save"}
                    clicked={OnSubmit}
                  />
                )}
              </Box>
            </Box>
          </Box>
          <ConfirmationAlert
            open={openConfirmation}
            close={() => {
              setOpenConfirmation(false);
            }}
            icon={<InfoIcon width={"4.8rem"} height={"4.8rem"} />}
            title={"Info !"}
            subTitle={`Pan Name and Lead Name Doesn't match.Do you want to use pan name ${panName}`}
            confirm={(value) => {
              if (value === "confirmed") {
                setVerified(true);
                setChangeLeadName(true);
              } else if (value === "rejected") {
                // setVerified(false);
                setVerifyAadhar(true);
                setVerifyPan(true);
                setPanNumber("");
                if (kycOption === false) {
                  setVerified(true);
                } else {
                  setVerified(false);
                }
                HelperText.isPanValid = false;
              }

              setOpenConfirmation(false);
              // console.log(value);
            }}
            buttonTitle={"No"}
            returnRespButton={"Yes"}
          />
        </Box>
      </Modal>
    </>
  );
}

export default AddSiteVisit;
